export const DEFAULT_SLIDES_TO_SHOW = 4;
